<template>
  <div class="form-group">
    <label>{{ __('E-mail do remetente') }}</label>
    <div v-if="! loading">
      <div
        class="d-flex"
        v-if="verifiedDomains.length"
      >
        <input
          class="form-control right border-salesflow-outline-gray-medium placeholder-salesflow-outline-gray-medium"
          v-model="from[0]"
          @input="emitJoined"
          :placeholder="__('Remetente')"
          required="required"
        >
        <div class="d-flex justify-content-center align-items-center input-background pl-1">
          @
        </div>
        <Multiselect
          class="form-control p-0 left"
          v-model="from[1]"
          :options="verifiedDomains"
          :searchable="false"
          :show-labels="false"
          @input="emitJoined"
        />
      </div>

      <input
        class="form-control border-salesflow-outline-gray-medium placeholder-salesflow-outline-gray-medium"
        type="email"
        v-model="newValue"
        @input="$emit('input', newValue)"
        placeholder="E-mail"
        required="required"
        v-else
      >
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      required: true,
    },
  },

  mounted () {
    this.loadDomains();

    if (this.value) {
      this.from = this.value.split('@');
      this.newValue = this.value;
    }
  },

  data: () => ({
    loading: true,
    newValue: '',
    from: [
      '',
      '',
    ],
    verifiedDomains: [
      //
    ],
  }),

  watch: {
    value: {
      handler (value) {
        if (value) {
          this.from = value.split('@');
        }
      },
    },
  },

  methods: {
    loadDomains () {
      this.loading = true;

      this.$http.get('/settings/domain')
        .then(({ data }) => {
          this.verifiedDomains = data.filter((domain) => domain.verified).map(((domain) => domain.domain));

          if (this.verifiedDomains.length && ! this.from[1]) {
            this.from[1] = this.verifiedDomains[0];
          }

          this.loading = false;
        })
        .catch(() => {
          this.verifiedDomains = [];
          this.loading = false;
        });
    },

    emitJoined () {
      let [first, last] = this.from;

      if (typeof last === 'undefined' || last === null) {
        last = '';
      }

      this.$emit('input', `${first}@${last}`);
    },
  },
};
</script>

<style lang="scss" scoped>
  .left {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .right {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    width: 50%;
    padding-right: 0;
  }

  .input-background {
    background: #FFFFFF;
  }

  span.multiselect__single {
    padding-left: 0;
    color: #3B334A;
  }
</style>
